import React from 'react'
import { Col, Row, Input, Select, Button, DatePicker, message } from 'antd'
import moment from 'moment'
import { saveAs } from "file-saver";
import XlsxPopulate from "xlsx-populate";
import Utils from '../../../utils/Utils'
import inventorySrc from '../inventorySrc'

const { Option } = Select
const { Search } = Input

function DownloadTabsHeader(props) {
  function getSheetData(data, header) {
    var fields = Object.keys(data[0]);
    var sheetData = data.map(function (row) {
      return fields.map(function (fieldName) {
        return row[fieldName] ? row[fieldName] : "";
      });
    });
    sheetData.unshift(header);
    return sheetData;
  }

  const setInventory = inventory => {
    if (inventory !== 'Too Many Attempts.') {
      let _inventory = inventory.data || []

      return _inventory.map((d, i) => ({
        key: i,
        avg_product_unit_cost: d.avg_product_unit_cost,
        product: d.product.description,
        quantity: d.quantity,
        store: d.store.name
      }))
    } else {
      message.error('Se excedió el limte de peticiones, espera y recarga la aplicación')
    }
  }

  async function saveAsExcel() {
    let header = ["Producto", "Cantidad", "Costo promedio unitario"];
    const today = new Date().toLocaleDateString("en-US")

    inventorySrc
      .getStockOptions(props.selectedOption, false, '', props.lowStock, true)
      .then(res => {
        if (res?.errors && Object.keys(res.errors)?.length > 0) {
          Utils.checkErrors(res)
        } else {
          const dataInventory = setInventory(res)
          if (dataInventory.length > 0) {
            
            let modifiedArr = dataInventory.map(element => {
              const obj = {
                Producto: element.product,
                Cantidad: element.quantity,
                Costo: element.avg_product_unit_cost
              }

              return obj;
            });

            XlsxPopulate.fromBlankAsync().then(async (workbook) => {
              const sheet1 = workbook.sheet(0);
              const sheetData = getSheetData(modifiedArr, header);
              const totalColumns = sheetData[0].length;

              sheet1.cell("A1").value(sheetData);
              const range = sheet1.usedRange();
              const endColumn = String.fromCharCode(64 + totalColumns);
              sheet1.row(1).style("bold", true);
              sheet1.range("A1:" + endColumn + "1").style("fill", "BFBFBF");
              sheet1.column("A").width(35)
              sheet1.column("c").width(25)
              range.style("border", true);
              return workbook.outputAsync().then((res) => {
                saveAs(res, dataInventory[0].store + "-" + today + ".xls");
              });
            });
          } else {
            message.error(`No posee inventario disponible`)
          }
        }
      })
      .catch(e => {
        message.error('No se ha podido cargar el inventario.')
      })
  }

  return (
    <Row gutter={16}>
      <Col xs={7} sm={7} md={7} lg={7}>
        <Select
          value={props.selectedOption}
          className={'single-select'}
          placeholder={'Selecciona una tienda'}
          size={'large'}
          style={{ width: '100%' }}
          onChange={option => {
            props.setSelectedOption(option)
          }}
        >
          {props.shopsList.map(option => (
            <Option key={option.id} value={option.id}>
              {option.name}
            </Option>
          ))}
        </Select>
      </Col>
      <Col xs={11} sm={11} md={11} lg={11}>
        {!!props.selectedOption &&
          (!props.keyTab || props.keyTab === '6' || props.keyTab === '6' ? (
            <Search
              placeholder={props.keyTab === '6' ? 'Buscar por número de factura' : 'Buscar por nombre de producto'}
              className={'tendero-table-search custom-search'}
              size={'large'}
              onSearch={props.onSearch}
            />
          ) : (
            <DatePicker
              placeHolder="Buscar por fecha"
              size={'large'}
              format={'YYYY-MM-DD'}
              className={'date-picker-custom'}
              disabledDate={current => current && current > moment().endOf('day')}
              onChange={(date, dateString) => props.onSearch(dateString)}
            />
          ))}
      </Col>
      <Col xs={6} sm={6} md={6} lg={6}>
        {!!props.selectedOption &&
          <Button style={{ width: '100%', height: '100%', color: 'var(--tendero-green)', background: '#ddefe8', border: '#cdcdcd' }} className={'new-deposit'} onClick={saveAsExcel}>
            Descargar CSV
          </Button>
        }
      </Col>

    </Row>
  )
}

export default DownloadTabsHeader

DownloadTabsHeader.defaultProps = {
  selectedOption: null,
  buttonLabel: null,
  shopsList: [],
}
